import { Search1Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onSearch: () => void;
  className?: string;
}

export const ActionBar = ({ onSearch, className }: ActionBarProps) => {
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Danh sách các phiếu thu</h1>
          <div className='text-[10px] text-gray-500'>
            <p>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              <span className='font-semibold'>Phân bổ thu tiền cho các hóa đơn</span>
            </p>
          </div>
        </div>
      }
    >
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearch} variant='primary' />
    </ActionBarV2>
  );
};

export default ActionBar;
